import type { FC, MouseEventHandler, ReactNode } from 'react'
import styled from '@emotion/styled'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

interface VideoCardProps {
  logo: ReactNode
  image: string
  onClick: MouseEventHandler<HTMLButtonElement>
}

const VideoCard: FC<VideoCardProps> = ({ logo, image, onClick }) => {
  return (
    <StyledCard onClick={onClick}>
      <StyledImage variant="fill" src={image} alt="" />
      <StyledBody>{logo}</StyledBody>
      <StyledPlayButton />
    </StyledCard>
  )
}

const StyledCard = styled(CardBase)`
  position: relative;
  cursor: pointer;
`

const StyledImage = styled(Card.Image)`
  height: 240px;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    height: 260px;
  }
`

const StyledBody = styled(Card.Body)`
  padding: 18px;
  justify-content: start;

  svg,
  img {
    display: inline-block;
    height: 22px;
    width: auto;
  }
`

const StyledPlayButton = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  width: 80px;
  height: 80px;
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
  border-radius: 50%;
  transition: 300ms ease;

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    width: 88px;
    height: 88px;
  }

  ::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    transform: translate(-40%, -50%);
    border-top: 14px solid transparent;
    border-bottom: 14px solid transparent;
    border-left: 26px solid ${({ theme }) => theme.palette.twilio.blue[60]};
  }

  :hover {
    background: ${({ theme }) => theme.palette.twilio.blue[60]};

    ::before {
      border-left: 26px solid ${({ theme }) => theme.palette.neutrals.white[100]};
    }
  }
`

export default VideoCard
